import React from 'react';
import { WELL,HOUSE,PILLAR } from '../../Constants/ConstantsOptics';

const CableConnectionsModal = ({ flagVisibleCable, dataStartCable, dataEndCable, dataConnectionCable, deleteStartCable, deleteEndCable,
  deleteCableCoupling, deleteCablePonBox, deleteCableFob, deleteCablePillar, deleteCableWell, deleteCableHouse, deleteCableLineParent, deleteCableCassette, id}) => {

  return (
<div>
    <div>
    <div style={{  display: flagVisibleCable ? 'flex' : 'none', justifyContent: 'center' }}>
    <div className='divStartEndCableModal'>
    {dataStartCable.length === 0 ? (
      <label style={{ color: '#ff9c9c' }}>Start кабеля не указан</label>
      ) : (
          dataStartCable.map((item) => (
              <>
                  {item.houseId ? (
                    <>
                      <label style={{ color: '#dfab01' }}>Start кабеля:
                        <hr className='horizontalLine2Modal'/>                     
                        <span style={{ color: '#cccccc' }}>{item.street}<br/> дом. {item.houseNumber}<br/> под. {item.entrance}</span></label>
                        <br/>
                        <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteStartCable(id, item.houseId, HOUSE)}> Удалить</button>
                    </>
                        
                  ) : null}
                  {item.wellId ? (
                    <>
                      <label style={{ color: '#dfab01' }}>Start кабеля:
                       <hr className='horizontalLine2Modal'/> 
                       <span style={{ color: '#cccccc' }}>Колодец: ID {item.wellId}</span></label> 
                       <br/>
                       <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteStartCable(id, item.wellId, WELL)}> Удалить</button>
                    </>
                  ) : null}
                  {item.pillarId ? (
                    <>
                     <label style={{ color: '#dfab01' }}>Start кабеля:
                     <hr className='horizontalLine2Modal'/> 
                     <span style={{ color: '#cccccc' }}>Опора: ID {item.pillarId}</span></label>  
                     <br/>
                     <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteStartCable(id, item.pillarId, PILLAR)}> Удалить</button>
                    </>                   
                  ) : null}
                   
              </>
              
          ))
      )}
    </div>
    <img style={{marginLeft:'10px',marginRight: '10px', width: '40px', height: '40px'}} src='./vektor.png' alt='вектор' />
  
    <div className='divStartEndCableModal'>
    {dataEndCable.length === 0 ? (
      <label style={{ color: '#ff9c9c' }}>End кабеля не указан</label>
      ) : (
          dataEndCable.map((item) => (
              <>
                  {item.houseId ? (
                    <>
                      <label style={{ color: '#dfab01' }}>End кабеля:
                        <hr className='horizontalLine2Modal'/>
                        <span style={{ color: '#cccccc' }}>{item.street}<br/> дом. {item.houseNumber}<br/> под. {item.entrance}</span></label>
                        <br/>
                        <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteEndCable(id, item.houseId, HOUSE)}> Удалить</button>
                    </>
                  ) : null}
                  {item.wellId ? (
                    <>
                      <label style={{ color: '#dfab01' }}>End кабеля:
                       <hr className='horizontalLine2Modal'/> 
                       <span style={{ color: '#cccccc' }}>Колодец: ID {item.wellId}</span></label> 
                        <br/>
                        <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteEndCable(id, item.wellId, WELL)}> Удалить</button>
                     </>
                  ) : null}
                  {item.pillarId ? (
                    <>
                      <label style={{ color: '#dfab01' }}>End кабеля:
                      <hr className='horizontalLine2Modal'/> 
                      <span style={{ color: '#cccccc' }}>Опора: ID {item.pillarId}</span></label>      
                      <br/>
                      <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteEndCable(id, item.pillarId, PILLAR)}> Удалить</button>
                     </>                 
                  ) : null} 
              </>
          ))
      )}
    </div>       
  </div> 
  <hr className='horizontalLineModal' style={{ display: flagVisibleCable ? 'block' : 'none' }} />     
  </div>


 <div style={{justifyContent: 'center'}}>
        <label style={{ color: '#dfab01', display: flagVisibleCable ? 'block' : 'none', fontSize: "18px" }}>Связи</label>

    {flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
      <>
        {dataConnectionCable.listConnectionCable.some(item => item.couplingLocationId !== null) && (
           <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./сoupling.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: "18px" }}>Муфта</label>
                <hr className='horizontalLine2Modal'/>
                {dataConnectionCable.listConnectionCable.map((item, index) => (
                    item.couplingLocationId !== null && (
                        <div className='divBodyConnectModal' key={index}> 
                            <span style={{fontWeight: 'bold'}}>ID: {item.couplingLocationId}</span>
                            <br/>
                            <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.couplingLatitude}, {item.couplingLongitude}</span>  
                            <br/>
                            <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteCableCoupling(id, item.couplingLocationId)}> Удалить</button>    
                        </div>
                    )
                ))}
           </div>
        )}
     </>
    )}

    {flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
      <>
        {dataConnectionCable.listConnectionCable.some(item => item.ponBoxLocationId !== null) && (
           <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./ponbox.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: "18px" }}>Пон-бокс</label>
                <hr className='horizontalLine2Modal'/>
                {dataConnectionCable.listConnectionCable.map((item, index) => (
                    item.ponBoxLocationId !== null && (
                        <div className='divBodyConnectModal' key={index}> 
                            <span style={{fontWeight: 'bold'}}>ID: {item.ponBoxLocationId}</span>
                            <br/>
                            <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.ponBoxLatitude}, {item.ponBoxLongitude}</span>  
                            <br/>
                            <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteCablePonBox(id, item.ponBoxLocationId)}> Удалить</button>     
                        </div>
                    )
                ))}
           </div>
        )}
     </>
    )}


{flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
    <>
     {dataConnectionCable.listConnectionCable.some(item => item.fobLocationId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./fob.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px" }}>Фоб</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCable.listConnectionCable.map((item, index) => (
        item.fobLocationId !== null && (
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.fobLocationId}</span>
          <br/>
          <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.fobLatitude}, {item.fobLongitude}</span>  
          <br/>
          <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteCableFob(id, item.fobLocationId)}> Удалить</button>        
          </div>
        )
      ))}
      </div>
    )}
    </>
  )}


 
  {flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
    <>
     {dataConnectionCable.listConnectionCable.some(item => item.pillarId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./pillar.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px" }}>Опора</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCable.listConnectionCable.map((item, index) => (
        item.pillarId !== null && (
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.pillarId}</span>
          <br/>
          <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.pillarLatitude}, {item.pillarLongitude}</span> 
          <br/>
          <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteCablePillar(id, item.pillarId)}> Удалить</button>     
          </div>
        )
      ))}
      </div>
    )}
    </>
  )}




{flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
    <>
    {dataConnectionCable.listConnectionCable.some(item => item.wellId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./manhole.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px" }}>Колодец</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCable.listConnectionCable.map((item, index) => (
        item.wellId !== null && (
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.wellId}</span>
          <br/>
          <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.wellLatitude}, {item.wellLongitude}</span>  
          <br/>
          <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteCableWell(id, item.wellId)}> Удалить</button>         
          </div>
        )
      ))}
       </div>
    )}
    </>
  )}

  {flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
    <>
    {dataConnectionCable.listConnectionCable.some(item => item.telecomCenterCassetteId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./cassette.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px" }}>Сплайс-кассета</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCable.listConnectionCable.map((item, index) => (
        item.telecomCenterCassetteId !== null && (
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.telecomCenterCassetteId}</span>
          <br/>
          <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteCableCassette(id, item.telecomCenterCassetteId)}> Удалить</button>         
          </div>
        )
      ))}
       </div>
    )}
    </>
  )}



{flagVisibleCable && dataConnectionCable && dataConnectionCable.houses && dataConnectionCable.houses.length > 0 && (
    <>
     {dataConnectionCable.listConnectionCable.some(item => item.houseId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./house.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px" }}>Дом</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCable.houses.map((item, index) => {
        const connectionItem = dataConnectionCable.listConnectionCable.find(connection => connection.houseId === item.id);
        return (
          <div className='divBodyConnectModal' key={index}> 
            <span style={{fontWeight: 'bold'}}>ID: {connectionItem ? connectionItem.houseId : 'N/A'}</span>
            <br/>
            <span style={{fontSize: "14px", color: "#202020"}}>
              {item.street}, дом. {item.house} под.{connectionItem ? connectionItem.entrance : 'N/A'}
            </span>  
            <br/>
            <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteCableHouse(id, connectionItem.houseId, connectionItem.entrance)}> Удалить</button>         
          </div>
        );
      })}
       </div>
    )}
    </>
)}



  {flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
    <>
     {dataConnectionCable.listConnectionCable.some(item => item.lineParentId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./cable.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px" }}>Кабель родитель</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCable.listConnectionCable.map((item, index) => (
        item.lineParentId !== null && (
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.lineParentId}</span>  
           <br/>
           <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deleteCableLineParent(id, item.lineParentId)}> Удалить</button>     
          </div>
        )
      ))}
        </div>
    )}
    </>
  )}
  
 <hr className='horizontalLineModal'/> 
</div>
</div>
  );
};
export default CableConnectionsModal;